// src/Components/Dashboard/Login/index.tsx
import React, { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'sonner';

export default function Login() {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const [error, setError] = useState<any | null>(null);
   const [isLoading, setIsLoading] = useState(false);
   const navigate = useNavigate();

   const handleLogin = async (e: React.FormEvent) => {
      e.preventDefault();
      setIsLoading(true);
      setError(null);

      try {
         const response = await axios.post("https://stagingbackend.pulp.ph/api/login", {
            username,
            password,
         });

         if (response.status === 201) {
            // Handle successful login
            console.log("Login successful:", response.data);
            const token = response.data.token;
            const role = response.data.role;
            const author = response.data.author;
            localStorage.setItem("authToken", token);
            localStorage.setItem("role", role);
            localStorage.setItem("author", author);
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            toast.success(<p className="text-[16px]">Successfully logged in!</p>, {
               duration: 1000,
            });
            // Redirect to the dashboard
            setTimeout(() => {
               navigate("/view/post/Show"); 
            }, 1100);
         } else {
            // Handle errors returned by the API
            setError(response.data.message || "Login failed");
         }
      } catch (err: unknown) {
         // Handle network errors
         if (axios.isAxiosError(err)) {
            const axiosError = err as AxiosError<any>; // Specify the response type as needed
            const errorMessage = axiosError.response?.data || "An unexpected error occurred";
            setError(errorMessage); // Assuming setError expects a string or null
         } else {
            setError("An unexpected error occurred");
         }
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <div className="flex flex-col justify-center items-center bg-live bg-black bg-cover bg-no-repeat bg-center h-screen w-screen">
         <form onSubmit={handleLogin} className="w-[356px] bg-white p-[30px] rounded-md">
            <div className="mb-3">
               <h2 className="GraphikSemibold text-center text-[36px] text-black font-semibold">Login</h2>
            </div>

            <div className="mb-3">
               <label htmlFor="username" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                  Username
               </label>
               <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                  <FontAwesomeIcon icon={faEnvelope} className="text-sm text-gray-400 mr-2" />
                  <input
                     type="text"
                     id="username"
                     value={username}
                     className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                     onChange={(e) => setUsername(e.target.value)}
                     placeholder="Enter your Username"
                     required/>
               </div>
            </div>

            <div className="mb-3">
               <label htmlFor="password" className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] mb-1">
                  Password
               </label>
               <div className="flex items-center border-[.7px] bg-white border-gray-400 shadow-[0_0_2px_#17202A66] focus-within:border-[1px] focus-within:border-[#131313] rounded-md py-2 pl-3 pr-2">
                  <FontAwesomeIcon icon={faLock} className="text-sm text-gray-400 mr-2" />
                  <input
                     type="password"
                     id="password"
                     value={password}
                     className="w-full text-sm tracking-[1px] text-black outline-none bg-white"
                     onChange={(e) => setPassword(e.target.value)}
                     placeholder="Enter your Password"
                     required/>
               </div>
            </div>

            {error && (
               <div className="flex justify-center bg-red-300 bg-opacity-40 border-[1px] border-red-300 p-2 rounded-md error m-0">
                  {Object.keys(error).map((key, index) => (
                     <label className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99]" key={index}>
                     <FontAwesomeIcon icon={faCircleExclamation} className="mr-2"/>
                  {error[key]}
                     </label>
                  ))}
               </div>
            )}

            <div className="flex justify-center mb-1">
               <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full text-sm tracking-[1px] text-white bg-red-600 hover:bg-red-800 active:transform active:translate-y-[1px] rounded-md p-2 mt-3">
                  {isLoading ? "Logging in..." : "Login"}
               </button>
            </div>

            <div className="flex justify-center">
               <label className="text-sm tracking-[1px] text-black [text-shadow:0px_0px_1px_#17202A99] p-2">
                  Don't have an account?
                  <a href="/register" className="text-sm tracking-[1px] text-red-600 [text-shadow:0px_0px_1px_#17202A99] hover:text-red-800 ml-1">
                     Sign Up
                  </a>
               </label>
            </div>
         </form>
      </div>
   );
}